// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HNU8","label":"styles_label__3cXha"};